<template>
<div class="top survey__top">
    <div class="inner is-spwide">
        <figure class="top__mv">
            <picture>
                <source media="(max-width: 750px)" srcset="/q/assets/img/mv_sp.webp">
                <img src="/q/assets/img/mv_pc.webp" alt="ラーメン山岡家">
            </picture>
        </figure>
    </div>
    <div class="inner">
        <div class="top__content">
            <p class="top__txt">
                ご来店ありがとうございます。<br>
                アプリをお持ちの方は来店ポイントを進呈いたします。<br>
                よろしければアンケートにもご回答ください。
            </p>
            <ul class="top__btn-list">
                <li class="top__btn-item">
                    <Btn class="top__btn is-app" :href="`${scheme}tab/bio/10537b10`">アプリでポイントゲット！</Btn>
                </li>
                <li class="top__btn-item">
                    <p class="top__btn-note">アンケートのみご回答いただける方はこちらから</p>
                    <Btn class="is-blue top__btn is-web" href="ans/">アンケートのみ回答する</Btn>
                </li>
            </ul>
        </div>
    </div>
</div>
</template>

<script>
import Btn from '../components/Btn.vue';

export default {
    components: {
        Btn,
    },

    props: {
        scheme: {
            type: String,
            default: 'yamaokaya:/'
        },
        shopId: {
            type: String,
            default: ''
        },
    },
}
</script>